import { Segment } from '../services/analytics-services/segment';
import { emptyObject } from 'ui-components/default-props/empty';

export const ShipFromTrackingSources = {
  HOME_PAGE_ONBOARDING_STEP: 'HOME_PAGE_ONBOARDING_STEP',
  GETTING_STARTED_GUIDE: 'GETTING_STARTED_GUIDE',
  FTU_WIZARD_SHIP_FROM_STEP: 'FTU_WIZARD_SHIP_FROM_STEP',
};

export const trackShipFromConfigStart = (source = '') => {
  Segment.trackEvent('SHIP_FROM_LOCATION_CONFIGURATION_START', {
    type: 'SHIP_FROM_LOCATION_CONFIGURATION_START',
    source,
  });
};

export const trackShipFromConfigComplete = (result = emptyObject, isFirstShipFromLocation = false, source = '') => {
  Segment.trackEvent('SHIP_FROM_LOCATION_CONFIGURATION_COMPLETE', {
    type: 'SHIP_FROM_LOCATION_CONFIGURATION_COMPLETE',
    ...result,
    isFirstShipFromLocation,
    source,
  });
};

export const trackShipFromEditButtonClick = (shipFromId, source = '') => {
  Segment.trackEvent('SHIP_FROM_LOCATION_EDIT_BUTTON_CLICK', {
    type: 'SHIP_FROM_LOCATION_EDIT_BUTTON_CLICK',
    shipFromId,
    source,
  });
};
